<template>
    <BootstrapModal ref="modal" :scrollable="true" class="modal-blur-header">
        <div class="modal-header modal-body-scrolled">
            <h5 class="modal-title my-auto">Likes</h5>
            <CloseButton @click="dismiss"/>
        </div>
        <div class="modal-body p-0">

            <div class="list-group list-group-bordered">
                <div v-for="like in likes" class="list-group-item">
                    <div class="list-group-item-figure">
                        <div class="user-avatar bg-gray">
                            <img :src="like.profile_image_url" alt="">
                        </div>
                    </div>
                    <div class="list-group-item-body">@{{ like.username }}</div>
                    <div class="list-group-item-figure">
                        <a v-if="like.public_profile_enabled" :href="like.public_profile_url" class="btn btn-sm btn-secondary">View Profile</a>
                        <span v-else class="text-muted">Private Profile</span>
                    </div>
                </div>
            </div>

            <LoadMoreButton v-if="next" :is-loading="isLoading" @load-more="loadMore"/>
            <div v-else class="text-center my-3">
                <div v-if="isLoading">
                    <i class="fad fa-2x fa-spin fa-spin-fast fa-spinner-third"></i>
                </div>
                <div v-else-if="likes.length === 0">No likes yet</div>
                <div v-else>That's all of the likes!</div>
            </div>

        </div>
    </BootstrapModal>
</template>

<script>
    import BootstrapModal from "./Modals/BootstrapModal";
    import LoadMoreButton from "./Modals/LoadMoreButton";
    import CloseButton from "./Modals/CloseButton";
    export default {
        components: {
            CloseButton,
            LoadMoreButton,
            BootstrapModal,
        },
        data: function() {
            return {
                isLoading: false,
                postCommentId: null,
                likes: [],
                next: null,
            }
        },
        methods: {
            show: function(postCommentId) {
                this.postCommentId = postCommentId;
                this.next = null;
                this.$refs.modal.show();
                this.load();
            },
            dismiss: function() {
                this.$refs.modal.hide();
            },
            load: function(next) {

                // clear likes on first load
                if(next == null){
                    this.likes = [];
                }

                this.isLoading = true;

                axios.get(next ? next : route('web-api.posts.comments.likes', this.postCommentId)).then((response) => {
                    const json = response.data;
                    json.data.forEach((like) => {
                        this.likes.push(like);
                    });
                    this.next = json.links.next;
                }).catch((error) => {
                    console.log(error);
                }).then(() => {
                    this.isLoading = false;
                });

            },
            loadMore: function() {
                this.load(this.next);
            },
        },
    }
</script>
